export default function ContactMap() {
  return (
    <section className="py-16 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden h-[500px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3487.234567890123!2d-81.6851!3d28.8528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7a1234567890a%3A0x1234567890abcdef!2s1321%20S%20Bay%20St%2C%20Eustis%2C%20FL%2032726!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0, filter: 'grayscale(20%) invert(90%) contrast(90%)' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="High Standards Smoke Shop Location Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
